import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { PlatformCallsCard } from "./-components/platform-calls-card";

export const Route = createFileRoute("/_authenticated/platform_/calls")({
  beforeLoad: ({ context }) => guardRoute(context.me, "platform-calls"),
  component: PlatformCalls,
});

/** Sarah's calls on People AI's own lines. */
function PlatformCalls() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="People AI calls"
        meta="The calls Sarah answered on People AI's own lines."
      />
      <PlatformCallsCard />
    </div>
  );
}
